/// <reference types="@websanova/vue-auth" />
import { datadogRum } from '@datadog/browser-rum';
import Vue from 'vue';
import Router from 'vue-router';
import { User } from '@/api';
import { version } from '../../package.json';

export function initRum(router: Router): void {
	const enabled = process.env.VUE_APP_DATADOG_ENABLED;
	if (enabled === 'false' || (process.env.NODE_ENV !== 'production' && enabled !== 'true')) {
		return;
	}

	datadogRum.init({
		applicationId: '96a22d9f-8f38-4644-b0a5-b4d2cbab1f05',
		clientToken: 'pubf3192b3fef014c2a3e750c1a704ba3b1',
		remoteConfiguration: {
			id: '80507b81-5ed7-4ec7-9317-03de0cdfa8b0',
		},
		site: 'ap2.datadoghq.com',
		service: 'admin-vue',
		env: process.env.VUE_APP_DATADOG_ENV || 'local',
		version,
		// Keep complete journeys for the small internal audience.
		sessionSampleRate: 100,
		sessionReplaySampleRate: 0,
		trackUserInteractions: true,
		trackViewsManually: true,
		trackResources: false,
		trackLongTasks: false,
		defaultPrivacyLevel: 'mask-user-input',
		beforeSend(event) {
			event.view.url = sanitizeUrl(event.view.url);
			if (event.view.referrer) {
				event.view.referrer = sanitizeUrl(event.view.referrer);
			}
			return true;
		},
	});

	router.afterEach((to, from) => {
		// Filters and anchors do not represent another page visit.
		if (from.matched.length && to.path === from.path) {
			return;
		}

		const record = to.matched[to.matched.length - 1];
		datadogRum.startView({ name: to.name || record?.path || 'unknown' });
	});
}

export function trackRumUser(app: Vue): void {
	if (!datadogRum.getInitConfiguration()) {
		return;
	}

	app.$watch(
		(): Partial<User> | null => (app.$auth.check() ? app.$auth.user() : null),
		user => {
			if (user?.id == null) {
				datadogRum.clearUser();
				return;
			}

			datadogRum.setUser({
				id: String(user.id),
				email: user.email,
				name: user.name || [user.firstName, user.lastName].filter(Boolean).join(' ') || undefined,
				role: user.role,
			});
		},
		{ immediate: true, deep: true },
	);
}

function sanitizeUrl(url: string): string {
	// Search terms and authentication links are not needed for navigation analysis.
	return url.replace(/[?#].*$/, '').replace(/(\/auth\/(?:reset|changeEmail)\/)[^/]+/, '$1:token');
}
